import { GlobalContext } from '../../utils/globalprovider';
import { forwardRef, useCallback, useContext, useEffect, useRef, useState } from 'react';

import './goto.css'
import { isDigit } from '../../applications/appcode/appcomponents/subtitles/list-st/utils/functions';

const GoToNumber = forwardRef((props, ref) => {
  const context = useContext(GlobalContext);
  const lang = context.language;

  const [text, setText] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    props.onChange(text);
  }, [text])

  useEffect(() => {

    if (inputRef && inputRef.current) {
     setTimeout(() => {
        inputRef.current.focus();
     }, 100);
    }

  }, [inputRef])

  const onKeyDown = useCallback((event) => {

    event.preventDefault();    
    event.stopPropagation();

     const input = inputRef.current;
    if (!input) return;

    const text = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    if (event.key === 'ArrowLeft') {
      if (start === 0) return;

      setCursorPosition(start - 1);
      return;
    }

    if (event.key === 'ArrowRight') {
      if (start === text.length) return;

      setCursorPosition(start + 1);
      return;
    }

    if (event.key === 'Backspace') {
      const value = text.substring(0, start - 1) + text.substring(end);
      updateText(value, start - 1);

      return;
    }

    if (event.key === 'Delete') {
      const value = text.substring(0, start) + text.substring(end + 1);
      updateText(value, start);

      return;
    }

    if (event.key === 'Home') {
      setCursorPosition(0);
      return;
    }

    if (event.key === 'End') {
      setCursorPosition(text.length);
      return;
    }

    if (event.key === "Enter") {
      props.handleButton('submit');
      return;
    }
    
    
    var char = event.key;

    if ((char.length > 1) || !isDigit(char)) {
      return;
    }

    const value = text.substring(0, start) + char + text.substring(end);
    updateText(value, start + 1);
  });

  const onChange = useCallback((event) => {
    const value = event.target.value.replace(/\D/g, '');
    setText(value);
  }, []);

  const updateText = (value, start) => {
    setText(value);

    // Ensure input stays focused after update
    setCursorPosition(start);
  };

  const setCursorPosition = (position) => {
    setTimeout(() => {
      const input = inputRef.current;

      input.setSelectionRange(position, position);
      input.scrollLeft = input.scrollWidth;
      input.focus();
    }, 0);
  };

  return (
    <>
      <div className="go-to-container">
        <label htmlFor="txtSubtitleNumber">
          {lang === 'fr' ? props.title.fr : props.title.en}
        </label>
        <input type="text"
          id="txtSubtitleNumber"
          value={text}
          ref={inputRef}
          onChange={onChange}
          onKeyDown={onKeyDown}></input>
      </div>
    </>
  );
});

export default GoToNumber;
